import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.dataCharts.loading;
export const selectErrorMessage = (state: RootState) => state.dataCharts.error;
export const dataChartsResponse = (state: RootState) =>
  state.dataCharts.dataChartsResponse;
